// TransactionHistory.jsx

import React, {useContext, useEffect, useState} from 'react';
import styles from './TransactionHistory.module.css';
import ConnectWalletHeader from "../header/ConnectWalletHeader";
import LeftPanel from "../SwapLeftPanel/LeftPanel";
import {useNavigate} from 'react-router-dom';

// Icons
import greyCircleSvg from "../static_files/circle.svg";
import arrowUpSvg from "../static_files/Vector Up.svg";
import arrowDownSvg from "../static_files/Vector Down.svg";
import expandSvg from "../static_files/expand.svg";
import expandHoverSvg from "../static_files/expandHover.svg";
import foldSvg from "../static_files/unexpand.svg";
import foldHoverSvg from "../static_files/unexpandHover.svg";
import uIconSvg from "../static_files/USDi.png";

import copyConfirmImg from "../static_files/copyConfirmMobile.png";

import shareLinkImg from "../static_files/shareButton.svg";
import shareLineHoverImg from "../static_files/shareButtonHover.svg";
import shareImg from "../static_files/share-selector.svg";
import shareHoverImg from "../static_files/share-selector-hover.svg";

import timeline1Img from "../static_files/timeline1.svg";
import timeline2Img from "../static_files/timeline2.svg";
import timeline3Img from "../static_files/timeline3.svg";
import timeline4Img from "../static_files/timeline4.svg";
import timeline5Img from "../static_files/timeline5.svg";
import noTransactionImg from "../static_files/No transaction.svg";
import {shortenAddress, formatAmount, useIsMobile, formatUTCTimeToLocal} from "../utils";

// Import CSSTransition for animation
import {CSSTransition} from "react-transition-group";
import {SwapMainAppContext} from "../../SwapMainAppContext";

import C2COrderDetail from "../C2C NetWork/C2COrderDetail";
import CancelOrderDetail from "../C2C NetWork/CancelOrderDetail";

import WireIcon from "../static_files/Wire.svg";
import USDIcon from "../static_files/usd.svg";
import ZelleIcon from "../static_files/Zelle.svg";
import VenmoIcon from "../static_files/Venmo.svg";
import AlipayIcon from "../static_files/Alipay.svg";

import RequestedTransactions from "./RequestedTransactions";
import SettleFunds from "../C2C NetWork/SettleFunds";
import TransactionHistoryLoader from "./TransactionHistoryLoader";

import Tooltip from "../Tooltip/Tooltip";
import AfterSettleFunds from "../C2C NetWork/AfterSettleFunds";
import CumulativeInterest from "./CumulativeInterest";
import CopyShareButtons from "./CopyShareButtons";
import { USDI_API_EUROPE_WEST_URL } from "../../configs/config";
import { submitCashReceived, submitC2cDispute } from "../../utils/c2cApi";

const paymentMethodIconMap = {
    "Bank Wire": WireIcon,
    "Physical Cash": USDIcon,
    "Zelle": ZelleIcon,
    "Venmo": VenmoIcon,
    "Alipay": AlipayIcon,
};

function TransactionHistory() {
    // for error messages
    const {showNotification} = useContext(SwapMainAppContext);
    const navigate = useNavigate();
    const isMobile = useIsMobile(768);
    const isSmallScreen = useIsMobile(1000)
    const [walletAddress, setWalletAddress] = useState("");
    const [groupedTransactions, setGroupedTransactions] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [isBlinking, setIsBlinking] = useState(false);

    const [expanded, setExpanded] = useState({});
    const [refetchFlag, setRefetchFlag] = useState(0);
    const [showPanel, setShowPanel] = useState(false);

    // Add loading state
    const [isLoading, setIsLoading] = useState(true);

    const [showCashReceivedConfirm, setShowCashReceivedConfirm] = useState(false);
    const [kiraPrice, setKiraPrice] = useState(null);
    const [selectedTx, setSelectedTx] = useState(null);
    const [orderDetails, setOrderDetails] = useState(null);
    const [emailWalletAddress, setEmailWalletAddress] = useState(null);

    const [showCancelOrderDetail, setShowCancelOrderDetail] = useState(false);
    const [cancelOrderDetails, setCancelOrderDetails] = useState(null);

    const [hasRequestedTxs, setHasRequestedTxs] = useState(false);
    const [hasCumulativeInterest, setHasCumulativeInterest] = useState(false);
    const [cumInterestLoading, setCumInterestLoading] = useState(false);
    const [showSettleFunds, setShowSettleFunds] = useState(false);
    const [showAfterSettleFunds, setShowAfterSettleFunds] = useState(false);
    // { txId, expiresAt } — set after submitting "Cash Received" so we keep
    // polling the backend for the collateral release result for a bounded time.
    const [collateralPollTarget, setCollateralPollTarget] = useState(null);
    const [allCashRedeemData, setAllCashRedeemData] = useState([])
    // ---------------- SHARE LINK TOOLTIP STATES & HANDLERS ----------------
    const [tooltipTextMap, setTooltipTextMap] = useState({});

    const [shrinkLeftPanel, setShrinkLeftPanel] = useState(() => {
        const savedState = localStorage.getItem('shrinkLeftPanel');
        return savedState !== null ? JSON.parse(savedState) : false;
    });

    const transactionContainerWidthShrink = shrinkLeftPanel ? '549.5' : '677';
    const handlePanelStateChange = (isPanelShrunk) => {
        setShrinkLeftPanel(isPanelShrunk);
    };

    // Copy link & show "Link Copied" for 2s
    const handleShareClick = (txId) => {
        const shareUrl = `https://app.kira.trading/transaction?txId=${txId}`;

        navigator.clipboard.writeText(shareUrl)
            .then(() => {
                setTooltipTextMap((prev) => ({...prev, [txId]: "Link Copied"}));

                setTimeout(() => {
                    // 恢复为 Share Transaction
                    setTooltipTextMap((prev) => ({...prev, [txId]: "Share Transaction"}));
                }, 2000);
            })
            .catch((err) => {
                console.error("Failed to copy link:", err);
            });
    };
    const handleRedirectClick = (tx) => {
        const redirectUrl = `https://solscan.io/tx/${tx.signature}`;
        window.open(redirectUrl, '_blank');
    };
    // ----------------------------------------------------------------------

    // If the URL has ?txId=xxx, auto-expand that transaction row
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const txIdParam = params.get("txId");
        if (txIdParam) {
            setExpanded((prev) => ({...prev, [txIdParam]: true}));
        }
    }, [groupedTransactions]);

    useEffect(() => {
        if (!walletAddress) return;
        setGroupedTransactions([]);
        setHasMore(true);
        fetchUserHistory(1);

    }, [walletAddress, refetchFlag]);

    // After "Cash Received" is submitted, the Squads collateral release happens
    // server-side and can outlive our HTTP request (it may even succeed after
    // the request times out). Quietly poll the API — without touching the
    // visible list — until the release is executed, then refresh the list once.
    // Bounded: gives up after the expiresAt deadline (~5 min).
    useEffect(() => {
        if (!collateralPollTarget || !walletAddress) return;

        let cancelled = false;

        const checkStatus = async () => {
            try {
                const url = `${USDI_API_EUROPE_WEST_URL}/cash_redeem/get_user_history?user_address=${walletAddress}&page=1&page_size=20`;
                const res = await fetch(url);
                const data = await res.json();
                if (cancelled) return;
                const redeem = (Array.isArray(data.cash_redeem) ? data.cash_redeem : []).find(
                    (r) => r.txs_id === collateralPollTarget.txId
                );
                const squadsStatus = (redeem?.collateral_release_squads_transaction_status || '').toLowerCase();
                if (squadsStatus === 'executed') {
                    setCollateralPollTarget(null);
                    setRefetchFlag((prev) => prev + 1);
                    showNotification('success', 'Collateral released — transaction completed.');
                }
            } catch (err) {
                // Transient poll failures are fine; the next tick retries.
                console.warn('Collateral status poll failed:', err);
            }
        };

        checkStatus();
        const interval = setInterval(() => {
            if (Date.now() > collateralPollTarget.expiresAt) {
                setCollateralPollTarget(null);
                return;
            }
            if (document.visibilityState === 'visible') {
                checkStatus();
            }
        }, 10000);

        return () => {
            cancelled = true;
            clearInterval(interval);
        };
    }, [collateralPollTarget, walletAddress]);


    useEffect(() => {
        const interval = setInterval(() => {
            setIsBlinking((prev) => !prev);
        }, 600);
        return () => clearInterval(interval);
    }, []);


    const formatLocalDate = (dateStr) => {
        const dateObj = new Date(dateStr);
        if (isNaN(dateObj.getTime())) return dateStr;
        return dateObj.toLocaleString([], {
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
    };

    function parseCustomDate(timestampStr) {
        // 假设格式总是 "MM/DD/YYYY, HH:mm:ss"
        let temp = timestampStr.replace(",", "");
        const [datePart, timePart] = temp.split(" ");
        const [month, day, year] = datePart.split("/");
        const isoString = `${year}-${month}-${day}T${timePart}Z`;
        return new Date(isoString); // 例如 "2025-03-04T16:30:31"
    }

    async function fetchUserHistory(pageParam = 1, pageSize = 20, accumulatedRedeemData = []) {

        try {
            if (pageParam === 1) {
                setIsLoading(true);
                accumulatedRedeemData = [];
            } else {
                setIsLoading(false);
            }
            const url = `${USDI_API_EUROPE_WEST_URL}/cash_redeem/get_user_history?user_address=${walletAddress}&page=${pageParam}&page_size=${pageSize}`;
            const res = await fetch(url);
            const data = await res.json();
            if (!data || !Array.isArray(data.transaction_history)) {
                setHasMore(false);
                return;
            }
            const newTxHist = data.transaction_history;
            if (newTxHist.length < pageSize) {
                setHasMore(false);
            }

            // Get new redeem data and accumulate it
            const newCashRedeemData = Array.isArray(data.cash_redeem) ? data.cash_redeem : [];

            // Merge new cash redeem data with existing accumulated data
            const updatedCashRedeemData = [...accumulatedRedeemData, ...newCashRedeemData];
            // Update the state with accumulated cash redeem data
            if (newTxHist.length < pageSize) {
                setAllCashRedeemData(updatedCashRedeemData);
            }

            const visibleHistory = (data.transaction_history || []).filter(
                (tx) => (tx.status || "").toLowerCase() !== "failed"
            );

            const allTxs = visibleHistory.map((tx) => {
                const createdAt = parseCustomDate(tx.txs_created_timestamp);
                const timeStr = createdAt.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                });
                const dateStr = createdAt.toLocaleDateString([], {month: "long", day: "numeric"});
                const arrowDirection = tx.txs_type?.toLowerCase() === "mint" ? "down" : "up";

                // If redeem with method cash, display as "C2C"
                let displayType = tx.txs_type;
                if (tx.txs_type?.toLowerCase() === "redeem" && tx.method?.toLowerCase() === "cash") {
                    displayType = "C2C";
                }
                console.log('tx here', tx)
                const txObj = {
                    id: tx.txs_id,
                    arrowDirection,
                    type: displayType,
                    amount: formatAmount(tx.from_token_amount || 0),
                    address: tx.from_address || "",
                    chain: tx.chain?.toLowerCase() || "",
                    redeemFrom: formatAmount(tx.from_token_amount || 0),
                    timeStr,
                    dateStr,
                    createdAt, // used for sorting
                    cash_delivery_received_time: "--",
                    usdi_released_time: "--",
                    status:
                        tx.ex_squads_transaction_status && tx.ex_squads_transaction_status.toLowerCase() === "active"
                            ? "Pending"
                            : tx.ex_squads_transaction_status && tx.ex_squads_transaction_status.toLowerCase() === "executed"
                                ? "Completed"
                                :tx.ex_squads_transaction_status && tx.ex_squads_transaction_status.toLowerCase() === "proposal_created_failed"
                                    ? "Squads Failed"
                                    : tx.status && tx.status.toLowerCase() === "completed"
                                        ? "Completed"
                                        : tx.status && tx.status.toLowerCase() === "pending"
                                            ? "Pending"
                                            : tx.status && tx.status.toLowerCase() === "failed"
                                                ? "Txs Failed"
                                                : tx.status,
                    fulfill_deadline: tx.fulfill_deadline || "--",
                    // TODO change it
                    collateral_ratio: 2, // Hard-coded for now
                    networkFeePercentage: tx.fees_percent * 100,
                    eta: tx.eta || "--",
                    signature: tx.transaction_signature || '',
                    ex_squads_transaction_status: tx.ex_squads_transaction_status || '',
                    ex_squads_transaction_index: tx.ex_squads_transaction_index || '',
                    ex_squads_approved_addresses: tx.ex_squads_approved_addresses || [],
                    ex_squads_fund_released_timestamp: tx.ex_squads_fund_released_timestamp ? formatUTCTimeToLocal(tx.ex_squads_fund_released_timestamp) : '',
                    ex_squads_transaction_signature: tx.ex_squads_transaction_signature || '',
                    method: tx.method
                };
                // Find the matching cash_redeem record by txs_id.
                const matchingRedeem = updatedCashRedeemData.find((redeem) => redeem.txs_id === tx.txs_id);
                // console.log('tx.txs_id', updatedCashRedeemData)
                const statusMapping = {
                    order_created: "Order Created",
                    order_fulfilled: "USDi Released",
                    cash_received: "Cash Delivered",
                    completed: "Completed",
                    pending: "Pending",
                    canceled: "Order Canceled",
                };
                if (matchingRedeem) {
                    // console.log("matchingredeem", matchingRedeem.txs_id)
                    txObj.usdi_released_time = matchingRedeem.usdi_released_time
                        ? formatLocalDate(matchingRedeem.usdi_released_time)
                        : "--";
                    txObj.cash_delivery_received_time = matchingRedeem.cash_delivery_received_time
                        ? formatLocalDate(matchingRedeem.cash_delivery_received_time)
                        : "--";
                    txObj.node_operator_wallet = matchingRedeem.node_operator_wallet;
                    txObj.status =
                        statusMapping[matchingRedeem.status.toLowerCase()] || matchingRedeem.status;
                    txObj.payment_info_id = matchingRedeem.payment_info_id || "--";
                    //set if its settle funds now or user has been in next
                    txObj.fund_send_notified = matchingRedeem.fund_send_notified || false;
                    txObj.requestor_contact_email = matchingRedeem.requestor_contact_email;
                    txObj.requestor_contact_mobile_number = matchingRedeem.requestor_contact_mobile_number;
                    txObj.payment_info_object = matchingRedeem.payment_info_object
                    txObj.collateral_release_squads_transaction_status = matchingRedeem.collateral_release_squads_transaction_status || "--";
                    txObj.collateral_release_squads_transaction_index = matchingRedeem.collateral_release_squads_transaction_index || "";
                    txObj.provider_conditional_approve_time = matchingRedeem.provider_conditional_approve_time
                        ? formatLocalDate(matchingRedeem.provider_conditional_approve_time)
                        : "--";
                    txObj.conditional_release_deadline = matchingRedeem.conditional_release_deadline
                        ? formatLocalDate(matchingRedeem.conditional_release_deadline)
                        : "--";
                    txObj.dispute_status = matchingRedeem.dispute_status || "";
                    txObj.dispute_reason = matchingRedeem.dispute_reason || "";
                    txObj.dispute_opened_time = matchingRedeem.dispute_opened_time
                        ? formatLocalDate(matchingRedeem.dispute_opened_time)
                        : "--";
                    txObj.dispute_opened_by = matchingRedeem.dispute_opened_by || "";
                    txObj.release_trigger_source = matchingRedeem.release_trigger_source || "";
                    txObj.collateral_released_timestamp = formatUTCTimeToLocal(
                        matchingRedeem.collateral_released_timestamp
                    );
                    txObj.refund_amount = matchingRedeem.refund_amount || "--";
                    txObj.canceled_time = formatUTCTimeToLocal(matchingRedeem.canceled_time) || "--";
                    txObj.refund_released_timestamp = formatUTCTimeToLocal(
                        matchingRedeem.refund_released_timestamp
                    );
                    txObj.refund_release_squads_transaction_signature = matchingRedeem.refund_release_squads_transaction_signature
                }

                return txObj;
            });

            // Group transactions by date
            const groupedMap = {};
            allTxs.forEach((tx) => {
                if (!groupedMap[tx.dateStr]) {
                    groupedMap[tx.dateStr] = [];
                }
                groupedMap[tx.dateStr].push(tx);
            });

            // Sort each day’s transactions (newest first)
            Object.keys(groupedMap).forEach((dateKey) => {
                groupedMap[dateKey].sort((a, b) => b.createdAt - a.createdAt);
            });

            // Convert to an array and sort by latest day first
            const groupedArr = Object.keys(groupedMap)
                .map((dateKey) => {
                    const latestTimestamp = groupedMap[dateKey][0].createdAt;
                    return {date: dateKey, items: groupedMap[dateKey], latestTimestamp};
                })
                .sort((a, b) => b.latestTimestamp - a.latestTimestamp)
                .map(({date, items}) => ({date, items}));

            setGroupedTransactions((prev) => {
                return [...prev, ...groupedArr];
            });
            if (newTxHist.length === pageSize) {
                const nextPage = pageParam + 1;
                fetchUserHistory(nextPage, pageSize, updatedCashRedeemData);
            } else {
                setHasMore(false);
            }
        } catch (err) {
            console.error("fetchUserHistory error:", err);
        } finally {
            setIsLoading(false);

        }
    }


    useEffect(() => {
        // Check if localStorage has a stored address (for email-logined user)
        const storedAddress = localStorage.getItem("emailUserWalletAddress");
        const storedAddress2 = localStorage.getItem("walletAddress");

        if (storedAddress) {
            setWalletAddress(storedAddress);
            setEmailWalletAddress(storedAddress);
        } else if (!storedAddress2) {
            setIsLoading(false)
        }
    }, []);


    const handleMyAssetsClick = () => {
        const token = localStorage.getItem("gatewayToken");
        if (token) {
            navigate(`/swap?token=${token}`);
        } else {
            navigate("/");
        }
    };

    function toggleExpand(txId) {
        setExpanded((prev) => ({
            ...prev,
            [txId]: !prev[txId],
        }));
    }

    const handleClearTransactions = () => {
        setGroupedTransactions([]);
        window.location.reload();
    };

    const today = new Date();
    const todayStr = today.toLocaleDateString([], {month: "long", day: "numeric"});
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    const yesterdayStr = yesterday.toLocaleDateString([], {month: "long", day: "numeric"});

    const handleCancelCashRedeemClick = async (tx) => {
        setSelectedTx(tx);
        try {
            const details = {
                amount: tx.amount,
                txs_id: tx.id,
            };
            setCancelOrderDetails(details);
            setShowCancelOrderDetail(true);
        } catch (error) {
            console.error("Error fetching today's price:", error);
        }
    };

    const handleCancelCashRedeem = async () => {
        const tx = selectedTx;
        if (tx.status !== "Order Created") {
            showNotification("error", "This transaction cannot be canceled in its current status.");
            return;
        }

        try {
            const res = await fetch(
                "https://usdi-api-256611876551.europe-west1.run.app/cash_redeem/cancel_cash_redeem",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        txs_id: tx.id,
                    }),
                }
            );

            if (res.ok) {
                setRefetchFlag((prev) => prev + 1);
                showNotification("success", "Your transaction has been canceled successfully!");
            } else {
                showNotification("error", "Failed to cancel your transaction. Please try again.");
            }
        } catch (err) {
            showNotification("error", "An unexpected error occurred. Please try again.");
        }
    };

    // Helper function to fetch KIRA price with fallback APIs
    const fetchKiraPrice = async () => {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const yyyy = today.getFullYear();
        const formattedDate = `${dd}-${mm}-${yyyy}`;
        const KRA_TOKEN_ADDRESS = 'AY2Qidgrky4TFymeJKe36w5buY7QWK7TSd7obQLupump';
        
        let coingeckoPrice = null;
        let geckoterminalPrice = null;

        // Try CoinGecko first
        try {
            const coingeckoUrl = `https://api.coingecko.com/api/v3/coins/kirakuru/history?date=${formattedDate}&localization=false`;
            const response = await fetch(coingeckoUrl);
            const data = await response.json();
            console.log("KIRA price data (CoinGecko):", data);
            
            if (
                data &&
                data.market_data &&
                data.market_data.current_price &&
                data.market_data.current_price.usd
            ) {
                coingeckoPrice = parseFloat(data.market_data.current_price.usd);
            }
        } catch (error) {
            console.warn("CoinGecko API failed, trying fallback:", error);
        }

        // Try GeckoTerminal as backup
        try {
            const geckoterminalUrl = `https://api.geckoterminal.com/api/v2/networks/solana/tokens/${KRA_TOKEN_ADDRESS}/pools`;
            const response = await fetch(geckoterminalUrl, {
                headers: {
                    'Accept': 'application/json;version=20230203'
                }
            });
            const data = await response.json();
            console.log("KIRA price data (GeckoTerminal):", data);
            
            // Get the pool with highest liquidity (usually the most accurate price)
            if (data && data.data && Array.isArray(data.data) && data.data.length > 0) {
                // Sort by liquidity (descending) and get the first pool
                const sortedPools = data.data.sort((a, b) => {
                    const liquidityA = parseFloat(a.attributes.reserve_in_usd || 0);
                    const liquidityB = parseFloat(b.attributes.reserve_in_usd || 0);
                    return liquidityB - liquidityA;
                });
                
                const topPool = sortedPools[0];
                if (topPool && topPool.attributes && topPool.attributes.base_token_price_usd) {
                    geckoterminalPrice = parseFloat(topPool.attributes.base_token_price_usd);
                }
            }
        } catch (error) {
            console.warn("GeckoTerminal API failed:", error);
        }

        // If both prices exist, use the minimum
        if (coingeckoPrice !== null && geckoterminalPrice !== null) {
            const minPrice = Math.min(coingeckoPrice, geckoterminalPrice);
            console.log(`Both prices available - CoinGecko: ${coingeckoPrice}, GeckoTerminal: ${geckoterminalPrice}, Using minimum: ${minPrice}`);
            return minPrice;
        }

        // If only one price exists, use it
        if (coingeckoPrice !== null) {
            console.log(`Using CoinGecko price: ${coingeckoPrice}`);
            return coingeckoPrice;
        }

        if (geckoterminalPrice !== null) {
            console.log(`Using GeckoTerminal price: ${geckoterminalPrice}`);
            return geckoterminalPrice;
        }

        throw new Error("All price APIs failed. Please try again later.");
    };

    // Handle "Cash Received" button
    const handleCashReceivedClick = async (tx, toCashValue, networkFeeValue) => {
        setSelectedTx(tx);
        try {
            // 获取当天 KIRA 价格 (with fallback)
            const openPrice = await fetchKiraPrice();
            const formattedPrice = openPrice.toFixed(8);
            setKiraPrice(formattedPrice);

            const orderTips = networkFeeValue / 2;
            const collateralRatio = parseFloat(tx.collateral_ratio) || 2;
            const redeemFromVal = parseFloat(tx.redeemFrom);
            const collateralRequired = (redeemFromVal * collateralRatio) / openPrice;
            const fulfillDeadlineDate = new Date(Date.now() + 48 * 60 * 60 * 1000);
            const fulfillDeadline = fulfillDeadlineDate.toLocaleString(); // in user's local time
            const details = {
                cashDeliveryAmount: toCashValue,
                orderTips,
                fulfillDeadline,
                collateralRequired,
                collateralRatio,
            };
            setOrderDetails(details);
            setShowCashReceivedConfirm(true);
        } catch (error) {
            console.error("Error fetching today's price:", error);
            showNotification('error', `Failed to fetch KIRA price: ${error.message}. Please try again.`);
        }
    };

    const handleCashReceived = async () => {
        const utcTime = new Date().toISOString();
        const txId = selectedTx.id;
        try {
            await submitCashReceived(txId, walletAddress, utcTime);
            showNotification("success", "Cash received confirmed. Collateral release submitted to Squads.");
        } finally {
            // Runs on success, failure, and timeout alike: the backend may have
            // already executed the release on-chain even if the response never
            // arrived, so close the popup, refetch, and keep polling for the
            // final status instead of trapping the user in the modal.
            setShowCashReceivedConfirm(false);
            setOrderDetails(null);
            setRefetchFlag((prev) => prev + 1);
            setCollateralPollTarget({txId, expiresAt: Date.now() + 5 * 60 * 1000});
        }
    };

    const handleSettleFundsClick = (tx) => {
        setSelectedTx(tx);
        setShowSettleFunds(true);
    };

    const handleAfterSettleFundsClick = (tx) => {
        setSelectedTx(tx);
        setShowAfterSettleFunds(true);
    };

    const handleDisputeClick = async (tx) => {
        const reason = window.prompt(
            'Optional: describe why you are opening a dispute (payment not received, wrong amount, etc.)'
        );
        if (reason === null) return;
        try {
            await submitC2cDispute(tx.id, walletAddress, reason || '');
            setRefetchFlag((prev) => prev + 1);
            showNotification('success', 'Dispute submitted. Collateral release blocked; admin will review.');
        } catch (error) {
            showNotification('error', error.message || 'Dispute failed');
        }
    };

    const handleCumInterestDataLoaded = ({isCumLoading}) => {
        setCumInterestLoading(isCumLoading);
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                backgroundColor: "#04070D",
                minHeight: "100vh",
                width: "100vw",
            }}
        >
            {/* Left Panel */}
            <LeftPanel walletAddress={walletAddress} isTransactionPage={true}
                       onPanelStateChange={handlePanelStateChange}
            />

            <div className={styles.rightPanel} style={{display: "flex", flexDirection: "column"}}>
                <ConnectWalletHeader
                    toAddress="4dJ5ATt3BbJPrbYCZGLAXndi5DPaZZY9j1Sp8Hdh4ApH"
                    onWalletConnected={(publicKey) => {
                        setWalletAddress(publicKey);
                    }}
                    showPanel={showPanel}
                    setShowPanel={setShowPanel}
                    emailWallet={emailWalletAddress}
                    onClearTransactions={handleClearTransactions}
                />

                <div className={styles.transactionContainer}
                     style={{paddingLeft: `max(20px, calc(50vw - ${transactionContainerWidthShrink}px))`}}
                >
                    <div style={{display: isLoading ? 'inherit' : 'inherit'}}>

                        {(isLoading || groupedTransactions.length > 0 || hasRequestedTxs || hasCumulativeInterest) && (
                            <div className={styles.transactionsTitle}>Transactions</div>
                        )}
                        <CumulativeInterest
                            onHasCumulativeInterest={(hasTxs) => setHasCumulativeInterest(hasTxs)}
                            onDataLoaded={handleCumInterestDataLoaded}
                        />
                        {cumInterestLoading && (<RequestedTransactions
                            onHasRequestedTxsChange={(hasTxs) => setHasRequestedTxs(hasTxs)}
                        />)}
                    </div>
                    {isLoading || (walletAddress && !cumInterestLoading) ? (
                        <div style={{textAlign: "left"}}>
                            <TransactionHistoryLoader/>
                        </div>
                    ) : (
                        <>
                            {/* 如果没有 txs 且没有 hasRequestedTxs */}
                            {groupedTransactions.length === 0 && !hasRequestedTxs && !hasCumulativeInterest ? (
                                <div className={styles.noTransactionsContainer}>
                                    <img
                                        className={styles.noTransactionsIcon}
                                        src={noTransactionImg}
                                        alt="No transactions icon"
                                    />
                                    <h2 className={styles.noTransactionsTitle}>No transactions yet</h2>
                                    <p className={styles.noTransactionsDescription}>
                                        Start your journey by minting USDi. Once you perform transactions,
                                        they’ll appear here for easy tracking and management.
                                    </p>
                                    <button
                                        className={styles.noTransactionsButton}
                                        onClick={handleMyAssetsClick}
                                    >
                                        Mint USDi
                                    </button>
                                </div>
                            ) : (
                                <>
                                    {groupedTransactions.map((group, index) => (
                                            <div key={`${group.date}-${index}`}>
                                                <div className={styles.transactionsDayTitle}>
                                                    {group.date === todayStr
                                                        ? "Today"
                                                        : group.date === yesterdayStr
                                                            ? "Yesterday"
                                                            : group.date}
                                                </div>

                                                {group.items.map((tx) => {
                                                    const arrowIcon =
                                                        tx.arrowDirection === "down" ? arrowDownSvg : arrowUpSvg;
                                                    // If redeem with method cash => C2C => can expand if not canceled.
                                                    const canExpand =
                                                        tx.type.toLowerCase() === "c2c" || tx.ex_squads_transaction_index !== '';

                                                    const redeemFromValue = parseFloat(tx.redeemFrom);
                                                    const toCashValue = Math.floor(
                                                        redeemFromValue * (100 - tx.networkFeePercentage)
                                                    ) / 100;
                                                    const networkFeeValue = redeemFromValue - toCashValue;

                                                    // Hide Cancel/Cash Received progress buttons only for
                                                    // large-amount mint & redeem (Squads flow). C2C orders go
                                                    // through a different Squad address and always keep their
                                                    // action buttons regardless of amount. Small mint/redeem
                                                    // never reach this detail panel (canExpand === false).
                                                    const isLargeMintOrRedeem =
                                                        tx.type?.toLowerCase() !== "c2c" &&
                                                        tx.ex_squads_transaction_index !== '';

                                                    const isRequestor =
                                                        tx.address.toLowerCase() === walletAddress.toLowerCase();
                                                    const isNodeOperator =
                                                        tx.node_operator_wallet &&
                                                        tx.node_operator_wallet.toLowerCase() === walletAddress.toLowerCase();
                                                    const collateralExecuted =
                                                        tx.collateral_release_squads_transaction_status === "executed";
                                                    const cashConfirmed =
                                                        tx.cash_delivery_received_time !== "--" ||
                                                        tx.status === "Cash Delivered";
                                                    const disputeOpen = tx.dispute_status === "open";
                                                    const cashReceivedSubmitted =
                                                        cashConfirmed ||
                                                        Boolean(tx.collateral_release_squads_transaction_index);
                                                    const squadsActive =
                                                        (tx.collateral_release_squads_transaction_status || '')
                                                            .toLowerCase() === 'active';
                                                    const canClickCashReceived =
                                                        !collateralExecuted &&
                                                        !disputeOpen &&
                                                        !cashReceivedSubmitted &&
                                                        tx.usdi_released_time !== "--" &&
                                                        tx.fund_send_notified &&
                                                        (isRequestor || isNodeOperator);
                                                    const canDispute =
                                                        !collateralExecuted &&
                                                        !disputeOpen &&
                                                        cashReceivedSubmitted &&
                                                        squadsActive &&
                                                        isRequestor;

                                                    const displayStatus =
                                                        tx.type?.toLowerCase() === 'c2c' && isNodeOperator
                                                            ? collateralExecuted
                                                                ? 'Collateral Released'
                                                                : disputeOpen
                                                                    ? 'Dispute Open'
                                                                    : cashReceivedSubmitted
                                                                        ? 'Collateral Pending'
                                                                        : tx.status
                                                            : tx.status;

                                                    const operatorC2cCollateralFlow =
                                                        isNodeOperator &&
                                                        tx.type?.toLowerCase() === 'c2c' &&
                                                        cashReceivedSubmitted;

                                                    const getStatusClassName = (statusLabel) => {
                                                        const normalized = (statusLabel || '').toLowerCase();
                                                        if (normalized === 'txs failed' || normalized === 'squads failed') {
                                                            return styles.statusFailed;
                                                        }
                                                        if (
                                                            normalized === 'completed' ||
                                                            normalized === 'cash delivered' ||
                                                            normalized === 'collateral released'
                                                        ) {
                                                            return styles.statusCompleted;
                                                        }
                                                        return styles.statusPending;
                                                    };

                                                    return (
                                                        <div className={styles.transactionRowOuterContainer} key={tx.id}>
                                                            {/* Main Transaction Row */}
                                                            <div
                                                                className={`${styles.transactionRow} ${
                                                                    canExpand && expanded[tx.id] ? styles.expandedRow : ""
                                                                }`}
                                                            >
                                                                <div className={styles.txTypeGroup}>
                                                                    <img
                                                                        className={styles.directionArrow}
                                                                        src={arrowIcon}
                                                                        alt="arrow"
                                                                    />
                                                                    <span className={styles.txType}>{tx.type}</span>
                                                                </div>

                                                                <div className={styles.uIconGroup}>
                                                                    <img className={styles.uIcon} src={uIconSvg}
                                                                         alt="USDi icon"/>
                                                                    <div className={styles.amountBox}>
                                                                        <span className={styles.amount}>
                                                                    {parseFloat(tx.amount).toLocaleString("en-US", {
                                                                        maximumFractionDigits: 6,
                                                                    })}
                                                                        </span>
                                                                        <span className={styles.usdi}> USDi</span>
                                                                    </div>
                                                                </div>

                                                                <div className={styles.toAddressGroup}>
                                                                    <span className={styles.to}>To:</span>
                                                                    <span className={styles.toAddress}>
                                                                {shortenAddress(tx.address)}
                                                            </span>
                                                                </div>
                                                                <span className={styles.time}>{tx.timeStr}</span>
                                                                {!isSmallScreen && (<span
                                                                    className={getStatusClassName(displayStatus)}
                                                                >
                                                                {displayStatus}
                                                            </span>)}
                                                                <div className={styles.shareIconGroup}>
                                                                    {isSmallScreen && (<span
                                                                        className={getStatusClassName(displayStatus)}
                                                                    >
                                                                {displayStatus}
                                                            </span>)}
                                                                    {canExpand ? (
                                                                        <div className={styles.shareBtn}
                                                                        >
                                                                            <Tooltip
                                                                                text={
                                                                                    tooltipTextMap[tx.id]
                                                                                        ? tooltipTextMap[tx.id]
                                                                                        : "Share Transaction"
                                                                                }

                                                                            >
                                                                                <img
                                                                                    className={styles.shareBtn}
                                                                                    src={
                                                                                        tooltipTextMap[tx.id] === "Link Copied"
                                                                                            ? copyConfirmImg
                                                                                            : shareLinkImg
                                                                                    }
                                                                                    alt="share"
                                                                                    style={{
                                                                                        width: "16px",
                                                                                        height: "16px",
                                                                                        cursor: "pointer",
                                                                                    }}
                                                                                    onMouseEnter={(e) => {
                                                                                        if (tooltipTextMap[tx.id] !== "Link Copied") {
                                                                                            e.currentTarget.src = shareLineHoverImg;
                                                                                        }
                                                                                    }}
                                                                                    onMouseLeave={(e) => {
                                                                                        if (tooltipTextMap[tx.id] !== "Link Copied") {
                                                                                            e.currentTarget.src = shareLinkImg;
                                                                                        }
                                                                                    }}
                                                                                    onClick={() => handleShareClick(tx.id)}
                                                                                />
                                                                            </Tooltip>
                                                                        </div>
                                                                    ) : (
                                                                        <div className={styles.shareBtn}
                                                                        >
                                                                            <Tooltip
                                                                                className={styles.shareBtn}

                                                                                text={
                                                                                    "Transaction Details"
                                                                                }
                                                                            >
                                                                                <img

                                                                                    src={shareImg}
                                                                                    alt="share"
                                                                                    style={{
                                                                                        width: "16px",
                                                                                        height: "16px",
                                                                                        cursor: "pointer",
                                                                                    }}
                                                                                    onMouseEnter={(e) => {
                                                                                        if (tooltipTextMap[tx.id] !== "Link Copied") {
                                                                                            e.currentTarget.src = shareHoverImg;
                                                                                        }
                                                                                    }}
                                                                                    onMouseLeave={(e) => {
                                                                                        if (tooltipTextMap[tx.id] !== "Link Copied") {
                                                                                            e.currentTarget.src = shareImg;
                                                                                        }
                                                                                    }}
                                                                                    onClick={() => handleRedirectClick(tx)}
                                                                                />
                                                                            </Tooltip>
                                                                        </div>
                                                                    )}
                                                                    {canExpand ? (
                                                                        <img
                                                                            className={styles.expandIcon}
                                                                            src={expanded[tx.id] ? foldSvg : expandSvg}
                                                                            alt="expand/fold"
                                                                            onClick={() => toggleExpand(tx.id)}
                                                                            onMouseEnter={(e) => {
                                                                                e.currentTarget.src = expanded[tx.id]
                                                                                    ? foldHoverSvg
                                                                                    : expandHoverSvg;
                                                                            }}
                                                                            onMouseLeave={(e) => {
                                                                                e.currentTarget.src = expanded[tx.id]
                                                                                    ? foldSvg
                                                                                    : expandSvg;
                                                                            }}
                                                                        />
                                                                    ) : isMobile ? <div></div> : (
                                                                        <img
                                                                            className={styles.expandIcon}
                                                                            src={expandSvg}
                                                                            alt="expand/fold"
                                                                            style={{visibility: "hidden"}}
                                                                        />
                                                                    )
                                                                    }
                                                                </div>
                                                            </div>


                                                            <CSSTransition
                                                                in={canExpand && expanded[tx.id]}
                                                                timeout={300}
                                                                classNames={{
                                                                    enter: styles.expandedEnter,
                                                                    enterActive: styles.expandedEnterActive,
                                                                    exit: styles.expandedExit,
                                                                    exitActive: styles.expandedExitActive,
                                                                }}
                                                                unmountOnExit
                                                            >
                                                                <div className={styles.expandedContainerOuter}>
                                                                    <div className={styles.lineWrapper}>
                                                                        <div className={styles.dividerLineFull}></div>
                                                                    </div>

                                                                    <div className={styles.expandedContainer}>
                                                                        {/* Info Section */}
                                                                        <div className={styles.expandedInfo}>
                                                                            <div className={styles.expandedSectionTitle}>
                                                                                Info
                                                                            </div>

                                                                            <div className={styles.expandedText}>
                                                                            <span className={styles.fixedLabel}>
                                                                                Redeem from:
                                                                            </span>
                                                                                <span className={styles.fetchedData}>
                                                                                {parseFloat(tx.redeemFrom).toLocaleString(
                                                                                    "en-US",
                                                                                    {
                                                                                        maximumFractionDigits: 6,
                                                                                    }
                                                                                )}{" "}
                                                                                    USDi
                                                                            </span>
                                                                            </div>

                                                                            <div className={styles.expandedText}>
                                                                            <span className={styles.fixedLabel}>
                                                                                To cash:
                                                                            </span>
                                                                                <span className={styles.fetchedData}>
                                                                                {toCashValue.toLocaleString("en-US", {
                                                                                    maximumFractionDigits: 2,
                                                                                    minimumFractionDigits: 2,
                                                                                })}{" "}
                                                                                    {tx.method === 'usdc' ? "USDC" : (
                                                                                        tx.method === 'usdt' ? "USDT" :
                                                                                            "USD"
                                                                                    )}
                                                                            </span>
                                                                            </div>

                                                                            <div className={styles.expandedText}>
                                                                            <span className={styles.fixedLabel}>
                                                                                Transaction type:
                                                                            </span>
                                                                                <span className={styles.fetchedData}>
                                                                                Redeem
                                                                            </span>
                                                                            </div>

                                                                            <div className={styles.expandedText}>
                                                                            <span
                                                                                className={styles.fixedLabel}>Time:</span>
                                                                                <span className={styles.fetchedData}>
                                                                                {tx.dateStr}, {tx.timeStr}
                                                                            </span>
                                                                            </div>

                                                                            <div className={styles.expandedText}>
                                                                            <span className={styles.fixedLabel}>
                                                                                Network:
                                                                            </span>{
                                                                                tx.type === 'C2C'
                                                                                    ? <Tooltip
                                                                                        text={<>A decentralized crypto-to-cash
                                                                                            network <br/>for on-ramp and
                                                                                            off-ramp
                                                                                            transactions</>}>
                                                                            <span style={{
                                                                                cursor: "default",
                                                                                borderBottom: '1.4px dotted #797979'
                                                                            }}
                                                                                  className={styles.fetchedData}>C2C</span>
                                                                                    </Tooltip> :
                                                                                    <span
                                                                                        className={styles.fetchedData}>Blockchain</span>
                                                                            }

                                                                            </div>

                                                                            <div className={styles.expandedText}>
                                                                                <Tooltip
                                                                                    text={<>The total amount charged by the
                                                                                        C2C <br/> network for processing
                                                                                        this
                                                                                        order</>}>

                                                                            <span style={{
                                                                                cursor: "default",
                                                                                borderBottom: '1.4px dotted #797979'
                                                                            }} className={styles.fixedLabel}>
                                                                                Network fee ({tx.networkFeePercentage}%):
                                                                            </span>
                                                                                </Tooltip>
                                                                                <span className={styles.fetchedData}>
                                                                                {networkFeeValue.toLocaleString("en-US", {
                                                                                    maximumFractionDigits: 2,
                                                                                    minimumFractionDigits: 2,
                                                                                })}{" "}
                                                                                    USDi
                                                                            </span>
                                                                            </div>

                                                                            <div className={styles.expandedText}>
                                                                            <span className={styles.fixedLabel}>
                                                                                Rate:
                                                                            </span>
                                                                                <span className={styles.fetchedData}>
                                                                                1 USDi = 1 {tx.method === 'usdc' ? "USDC" : (
                                                                                    tx.method === 'usdt' ? "USDT" :
                                                                                        "USD"
                                                                                )}
                                                                            </span>
                                                                            </div>

                                                                            <div className={styles.expandedText}>
                                                                            <span className={styles.fixedLabel}>
                                                                                ETA:
                                                                            </span>
                                                                                <span className={styles.fetchedData}>
                                                                                {tx.eta}
                                                                            </span>
                                                                            </div>
                                                                            <div className={styles.dividerLineFull2}></div>

                                                                            {tx.ex_squads_transaction_index ?
                                                                                <div className={styles.expandedNote}>
                                                                                    Notes: Your funds are securely stored in
                                                                                    the protocol multisig vault. Please wait
                                                                                    for signatures and release within 24
                                                                                    hours.
                                                                                </div> :
                                                                                <div className={styles.expandedNote}>
                                                                                    Notes: Wait for a node operator to fill
                                                                                    your
                                                                                    order after payment. You'll be notified
                                                                                    upon
                                                                                    delivery. For physical cash, the
                                                                                    operator
                                                                                    will contact you directly.
                                                                                </div>
                                                                            }
                                                                        </div>

                                                                        {/* Progress Section */}
                                                                        <div className={styles.expandedProgress}>
                                                                            <div className={styles.expandedSectionTitle}>
                                                                                Progress
                                                                            </div>
                                                                            <div className={styles.progressItemContainer}>
                                                                                <div>
                                                                                    {operatorC2cCollateralFlow ? (
                                                                                        <img
                                                                                            src={collateralExecuted ? timeline4Img : timeline5Img}
                                                                                            alt="timeline"
                                                                                        />
                                                                                    ) : (tx.usdi_released_time === "--" && tx.canceled_time === "--") || (tx.ex_squads_transaction_index !== '' && tx.ex_squads_transaction_status !== 'executed') ? (
                                                                                        <img
                                                                                            src={timeline1Img}
                                                                                            alt="timeline"
                                                                                        />
                                                                                    ) : tx.cash_delivery_received_time ===
                                                                                    "--" && tx.refund_released_timestamp === "--" ? (
                                                                                        <img
                                                                                            src={timeline2Img}
                                                                                            alt="timeline"
                                                                                        />
                                                                                    ) : (
                                                                                        <img
                                                                                            src={timeline3Img}
                                                                                            alt="timeline"
                                                                                        />
                                                                                    )}
                                                                                </div>

                                                                                <div
                                                                                    className={
                                                                                        tx.status.toLowerCase() !== 'order canceled'
                                                                                            ? operatorC2cCollateralFlow
                                                                                                ? styles.progressItemContainerLeftOperator
                                                                                                : styles.progressItemContainerLeft
                                                                                            : `${styles.progressItemContainerLeft2} ${styles.progressItemContainerLeft}`
                                                                                    }
                                                                                >
                                                                                    <div className={styles.progressItem}>

                                                                                        <Tooltip
                                                                                            text={<>
                                                                                                Fund secured in custodian
                                                                                                wallet. C2C <br/> operator
                                                                                                will
                                                                                                pledge collateral
                                                                                                before<br/> filling your
                                                                                                order.
                                                                                            </>}
                                                                                            link="https://docs.kira.trading/kira-club/c2c-network/c2c-redemption-process"
                                                                                        >

                                                                                            <span style={{
                                                                                                borderBottom: '1.4px dotted #797979',
                                                                                                cursor: "default"
                                                                                            }}>
                                                                                               Transaction Created
                                                                                            </span>
                                                                                        </Tooltip>
                                                                                        <div
                                                                                            className={styles.progressItemTime}>
                                                                                            {tx.dateStr}, {tx.timeStr}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className={styles.progressItem}>
                                                                                        {tx.ex_squads_transaction_index !== '' ?
                                                                                            <span>
                                                                                              Multisig Approval Voting
                                                                                            </span>
                                                                                            : (tx.status.toLowerCase() === "order canceled" ?
                                                                                                <Tooltip
                                                                                                    link="https://docs.kira.trading/kira-club/c2c-network/c2c-redemption-process"

                                                                                                    text={<>
                                                                                                        Transaction
                                                                                                        cancelled.
                                                                                                        Funds will <br/>return
                                                                                                        to your original
                                                                                                        wallet
                                                                                                        within<br/> 24
                                                                                                        hours.
                                                                                                    </>}>

                                                                                            <span style={{
                                                                                                borderBottom: '1.4px dotted #797979',
                                                                                                cursor: "default",
                                                                                            }}>
                                                                                               Transaction Cancelled
                                                                                            </span>
                                                                                                </Tooltip> :
                                                                                                <Tooltip
                                                                                                    link="https://docs.kira.trading/kira-club/c2c-network/c2c-redemption-process"

                                                                                                    text={<>
                                                                                                        Payment released.
                                                                                                        Funds
                                                                                                        will
                                                                                                        be
                                                                                                        delivered<br/> soon.
                                                                                                        For
                                                                                                        physical
                                                                                                        cash, the operator
                                                                                                        will
                                                                                                        <br/> contact you
                                                                                                        directly.
                                                                                                    </>}>

                                                                                            <span style={{
                                                                                                borderBottom: '1.4px dotted #797979',
                                                                                                cursor: "default",
                                                                                                color: tx.usdi_released_time !== "--" ? 'inherit' : '#bbbbbb',
                                                                                            }}>
                                                                                               USDi Released
                                                                                            </span>
                                                                                                </Tooltip>)
                                                                                        }

                                                                                        {tx.ex_squads_transaction_index !== '' ?
                                                                                            <div
                                                                                                className={styles.progressItemTime}>
                                                                                                {(tx.ex_squads_approved_addresses).length}/2
                                                                                                approved
                                                                                            </div>
                                                                                            : (tx.status.toLowerCase() === "order canceled" ?
                                                                                                <div
                                                                                                    className={styles.progressItemTime}>
                                                                                                    {tx.canceled_time || " "}
                                                                                                </div> : <div
                                                                                                    className={styles.progressItemTime}>
                                                                                                    {tx.usdi_released_time || " "}
                                                                                                </div>)
                                                                                        }
                                                                                    </div>
                                                                                    <div className={styles.progressItem}>
                                                                                        {tx.ex_squads_transaction_index !== '' ?
                                                                                            <span style={{
                                                                                                color: tx.ex_squads_transaction_status === "executed" ? 'inherit' : '#bbbbbb',
                                                                                            }}>
                                                                                               Fund Released
                                                                                            </span>
                                                                                            : (tx.status.toLowerCase() === "order canceled" ?
                                                                                                <span style={{
                                                                                                    color: tx.cash_delivery_received_time !== "--" ? 'inherit' : '#bbbbbb',
                                                                                                }}>
                                                                                               USDi Returned
                                                                                            </span>
                                                                                                : <Tooltip
                                                                                                    text={<>
                                                                                                        Funds has been
                                                                                                        delivered,
                                                                                                        once <br/>it's
                                                                                                        confirmed,
                                                                                                        the collateral
                                                                                                        will <br/>be
                                                                                                        released
                                                                                                    </>}
                                                                                                    link="https://docs.kira.trading/kira-club/c2c-network/c2c-redemption-process"
                                                                                                >

                                                                                            <span style={{
                                                                                                borderBottom: '1.4px dotted #797979',
                                                                                                cursor: "default",
                                                                                                color: tx.cash_delivery_received_time !== "--" ? 'inherit' : '#bbbbbb',

                                                                                            }}>
                                                                                               Cash Delivered
                                                                                            </span>
                                                                                                </Tooltip>)}
                                                                                        {/*todo change below*/}
                                                                                        {tx.ex_squads_transaction_index !== '' ?
                                                                                            <div style={{
                                                                                                display: 'flex',
                                                                                                flexDirection: 'row',
                                                                                                alignItems: 'center'
                                                                                            }}>
                                                                                                <div
                                                                                                    className={styles.progressItemTime}>
                                                                                                    {tx.ex_squads_fund_released_timestamp ||
                                                                                                        "--"}
                                                                                                </div>
                                                                                                {tx.ex_squads_transaction_signature !== '' && (
                                                                                                    <CopyShareButtons
                                                                                                        textToCopy={tx.ex_squads_transaction_signature}
                                                                                                        urlToOpen={`https://solscan.io/tx/${tx.ex_squads_transaction_signature}`}
                                                                                                        containerStyle={{
                                                                                                            marginTop: '10px',
                                                                                                            marginLeft: '10px'
                                                                                                        }}
                                                                                                    />)}
                                                                                            </div>


                                                                                            : (tx.status.toLowerCase() === "order canceled" ? <>
                                                                                                <div style={{
                                                                                                    display: 'flex',
                                                                                                    flexDirection: 'row',
                                                                                                    alignItems: 'center'
                                                                                                }}>
                                                                                                    <div
                                                                                                        className={styles.progressItemTime}>
                                                                                                        {tx.refund_released_timestamp ||
                                                                                                            " "}
                                                                                                    </div>
                                                                                                    {tx.refund_released_timestamp !== '--' && (
                                                                                                        <CopyShareButtons
                                                                                                            textToCopy={tx.refund_released_timestamp}
                                                                                                            urlToOpen={`https://solscan.io/tx/${tx.refund_released_timestamp}`}
                                                                                                            containerStyle={{
                                                                                                                marginTop: '10px',
                                                                                                                marginLeft: '10px'
                                                                                                            }}
                                                                                                        />)}
                                                                                                </div>

                                                                                                <div
                                                                                                    className={styles.progressItemTime}>
                                                                                                    {tx.refund_released_timestamp !== '--' && tx.refund_amount && tx.refund_amount !== "--"
                                                                                                        ? `${parseFloat(tx.refund_amount).toFixed(2)} USDi`
                                                                                                        : '--'}
                                                                                                </div>
                                                                                            </> : <div
                                                                                                className={styles.progressItemTime}>
                                                                                                {tx.cash_delivery_received_time ||
                                                                                                    " "}
                                                                                            </div>)}
                                                                                    </div>


                                                                                    {operatorC2cCollateralFlow && (
                                                                                        <div className={styles.progressItem}>
                                                                                            <span
                                                                                                style={{
                                                                                                    color: disputeOpen
                                                                                                        ? 'inherit'
                                                                                                        : collateralExecuted
                                                                                                            ? 'inherit'
                                                                                                            : '#bbbbbb',
                                                                                                }}
                                                                                            >
                                                                                                {disputeOpen && !collateralExecuted
                                                                                                    ? 'Dispute Open'
                                                                                                    : 'Collateral Released'}
                                                                                            </span>
                                                                                            <div className={styles.progressItemTime}>
                                                                                                {disputeOpen && !collateralExecuted
                                                                                                    ? (tx.dispute_opened_time !== '--'
                                                                                                        ? tx.dispute_opened_time
                                                                                                        : ' ')
                                                                                                    : collateralExecuted
                                                                                                        ? (tx.collateral_released_timestamp || ' ')
                                                                                                        : ' '}
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>


                                                                                <div
                                                                                    className={
                                                                                        operatorC2cCollateralFlow
                                                                                            ? styles.progressItemContainerRightOperator
                                                                                            : styles.progressItemContainerRight
                                                                                    }
                                                                                >
                                                                                    <div
                                                                                        className={styles.operatorWalletContainer}>
                                                                                        <div
                                                                                            className={styles.operatorWalletContainerLeft}>
                                                                                            <img
                                                                                                src={greyCircleSvg}
                                                                                                alt="O"
                                                                                            />
                                                                                            {tx.ex_squads_transaction_index !== '' ?
                                                                                                <div
                                                                                                    className={styles.c2cWallet}>
                                                                                                    {shortenAddress("4dJ5ATt3BbJPrbYCZGLAXndi5DPaZZY9j1Sp8Hdh4ApH")}
                                                                                                    <div
                                                                                                        className={styles.greyWalletAddress}>
                                                                                                        Kira Vault
                                                                                                    </div>
                                                                                                </div>
                                                                                                :
                                                                                                <div
                                                                                                    className={styles.c2cWallet}>
                                                                                                    {tx.address
                                                                                                        ? shortenAddress(tx.address)
                                                                                                        : " "}
                                                                                                    <div
                                                                                                        className={
                                                                                                            styles.greyWalletAddress
                                                                                                        }
                                                                                                    >
                                                                                                        C2C Ex Wallet
                                                                                                    </div>
                                                                                                </div>}
                                                                                        </div>
                                                                                        <div
                                                                                            className={styles.imgContainer}>
                                                                                            {tx.ex_squads_transaction_index ?
                                                                                                <CopyShareButtons
                                                                                                    textToCopy={'4dJ5ATt3BbJPrbYCZGLAXndi5DPaZZY9j1Sp8Hdh4ApH'}
                                                                                                    urlToOpen={`https://solscan.io/account/4dJ5ATt3BbJPrbYCZGLAXndi5DPaZZY9j1Sp8Hdh4ApH`}
                                                                                                /> :
                                                                                                <CopyShareButtons
                                                                                                    textToCopy={tx.address}
                                                                                                    urlToOpen={`https://solscan.io/account/${tx.address}`}
                                                                                                />}
                                                                                        </div>
                                                                                    </div>

                                                                                    {/*right second line*/}
                                                                                    <div
                                                                                        className={styles.operatorWalletContainer}>
                                                                                        <div
                                                                                            className={styles.operatorWalletContainerLeft}>
                                                                                            <img
                                                                                                src={greyCircleSvg}
                                                                                                alt="O"
                                                                                            />
                                                                                            {tx.ex_squads_approved_addresses.length > 0 ?
                                                                                                <div
                                                                                                    className={styles.c2cWallet}>
                                                                                                    {shortenAddress(tx.ex_squads_approved_addresses[0])}
                                                                                                    <div
                                                                                                        className={styles.greyWalletAddress}>
                                                                                                        Signed
                                                                                                    </div>
                                                                                                </div> :
                                                                                                <div
                                                                                                    className={styles.c2cWallet}>
                                                                                                    {tx.node_operator_wallet
                                                                                                        ? shortenAddress(
                                                                                                            tx.node_operator_wallet
                                                                                                        )
                                                                                                        : "--"}
                                                                                                    <div
                                                                                                        className={styles.greyWalletAddress}>
                                                                                                        {tx.ex_squads_transaction_index === '' ? "Node Operator Wallet" : "Signed"}
                                                                                                    </div>
                                                                                                </div>}

                                                                                        </div>
                                                                                        {tx.node_operator_wallet ? (
                                                                                            <CopyShareButtons
                                                                                                textToCopy={tx.node_operator_wallet}
                                                                                                urlToOpen={`https://solscan.io/account/${tx.node_operator_wallet}`}
                                                                                            />
                                                                                        ) : tx.ex_squads_approved_addresses.length > 0 ? (
                                                                                            <CopyShareButtons
                                                                                                textToCopy={tx.ex_squads_approved_addresses[0]}
                                                                                                urlToOpen={`https://solscan.io/account/${tx.ex_squads_approved_addresses[0]}`}
                                                                                            />
                                                                                        ) : <div></div>}
                                                                                    </div>

                                                                                    {/* Payment method — aligns with Cash Delivered */}
                                                                                    <div
                                                                                        className={styles.operatorWalletContainer}>
                                                                                        {/*Right third line*/}
                                                                                        <div
                                                                                            className={styles.operatorWalletContainerLeft}>
                                                                                            <img
                                                                                                src={
                                                                                                    tx.payment_info_object
                                                                                                        ? paymentMethodIconMap[
                                                                                                            tx.payment_info_object
                                                                                                                .payment_method
                                                                                                            ]
                                                                                                        : greyCircleSvg
                                                                                                }
                                                                                                alt="O"
                                                                                            />
                                                                                            {tx.ex_squads_approved_addresses.length > 1 ?
                                                                                                <div
                                                                                                    className={styles.c2cWallet}>
                                                                                                    {shortenAddress(tx.ex_squads_approved_addresses[1])}
                                                                                                    <div
                                                                                                        className={styles.greyWalletAddress}>
                                                                                                        Signed
                                                                                                    </div>
                                                                                                </div> :
                                                                                                <div
                                                                                                    className={styles.c2cWallet}
                                                                                                    style={{
                                                                                                        color: tx.cash_delivery_received_time !== "--" ? 'inherit' : '#bbbbbb',
                                                                                                    }}
                                                                                                >
                                                                                                    {tx.payment_info_object
                                                                                                        ? tx.payment_info_object
                                                                                                            .payment_method
                                                                                                        : "--"}
                                                                                                    <div
                                                                                                        className={styles.greyWalletAddress}>
                                                                                                        {tx.ex_squads_transaction_index === '' ? "Payment Method" : "Signed"}
                                                                                                    </div>
                                                                                                </div>}
                                                                                        </div>
                                                                                        {tx.ex_squads_approved_addresses.length > 1 ? (
                                                                                            <CopyShareButtons
                                                                                                textToCopy={tx.ex_squads_approved_addresses[1]}
                                                                                                urlToOpen={`https://solscan.io/account/${tx.ex_squads_approved_addresses[1]}`}
                                                                                            />
                                                                                        ) : <div></div>}
                                                                                    </div>

                                                                                    {/* 4th row: requestor wallet when dispute open, else spacer / operator wallet */}
                                                                                    {operatorC2cCollateralFlow && disputeOpen && !collateralExecuted && (
                                                                                        <div className={styles.operatorWalletContainer}>
                                                                                            <div
                                                                                                className={styles.operatorWalletContainerLeft}>
                                                                                                <img
                                                                                                    src={greyCircleSvg}
                                                                                                    alt="O"
                                                                                                />
                                                                                                <div className={styles.c2cWallet}>
                                                                                                    {shortenAddress(
                                                                                                        tx.dispute_opened_by || tx.address || '--'
                                                                                                    )}
                                                                                                    <div
                                                                                                        className={styles.greyWalletAddress}>
                                                                                                        C2C Ex Wallet
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <CopyShareButtons
                                                                                                textToCopy={tx.dispute_opened_by || tx.address}
                                                                                                urlToOpen={`https://solscan.io/account/${tx.dispute_opened_by || tx.address}`}
                                                                                            />
                                                                                        </div>
                                                                                    )}
                                                                                    {operatorC2cCollateralFlow && !disputeOpen && !collateralExecuted && (
                                                                                        <div
                                                                                            className={styles.progressRightSpacer}
                                                                                            aria-hidden="true"
                                                                                        />
                                                                                    )}
                                                                                    {operatorC2cCollateralFlow && collateralExecuted && (
                                                                                        <div
                                                                                            className={styles.operatorWalletContainer}>
                                                                                            <div
                                                                                                className={styles.operatorWalletContainerLeft}>
                                                                                                <img
                                                                                                    src={greyCircleSvg}
                                                                                                    alt="O"
                                                                                                />
                                                                                                <div
                                                                                                    className={styles.c2cWallet}>
                                                                                                    {tx.node_operator_wallet
                                                                                                        ? shortenAddress(
                                                                                                            tx.node_operator_wallet
                                                                                                        )
                                                                                                        : "--"}
                                                                                                    <div
                                                                                                        className={styles.greyWalletAddress}>
                                                                                                        Node Operator Wallet
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>

                                                                                            <CopyShareButtons
                                                                                                textToCopy={tx.node_operator_wallet}
                                                                                                urlToOpen={`https://solscan.io/account/${tx.node_operator_wallet}`}
                                                                                            />
                                                                                        </div>
                                                                                    )}

                                                                                </div>
                                                                            </div>

                                                                            {tx.status.toLowerCase() !== "completed" && tx.status.toLowerCase() !== "order canceled" ?
                                                                                <div className={styles.progressButtons}>
                                                                                    {tx.usdi_released_time === "--" ? (
                                                                                        isLargeMintOrRedeem ? (
                                                                                            <></>
                                                                                        ) : (
                                                                                            <>
                                                                                                <button
                                                                                                    onClick={() =>
                                                                                                        handleCancelCashRedeemClick(tx)
                                                                                                    }
                                                                                                    className={styles.progressButton2}
                                                                                                >
                                                                                                    Cancel
                                                                                                </button>
                                                                                                <button
                                                                                                    className={`${styles.progressButton} ${styles.progressButtonDisabled}`}
                                                                                                >
                                                                                                    Cash Received
                                                                                                </button>
                                                                                            </>
                                                                                        )
                                                                                    ) : isNodeOperator && !collateralExecuted && !tx.fund_send_notified && !cashReceivedSubmitted ? (
                                                                                        <button
                                                                                            onClick={() => handleSettleFundsClick(tx)}
                                                                                            className={styles.progressButton3}
                                                                                        >
                                                                                            Settle Funds Now
                                                                                        </button>
                                                                                    ) : canClickCashReceived ? (
                                                                                        <>
                                                                                            {isRequestor && !isLargeMintOrRedeem ? (
                                                                                                <button
                                                                                                    onClick={() =>
                                                                                                        handleCancelCashRedeemClick(tx)
                                                                                                    }
                                                                                                    className={styles.progressButton2}
                                                                                                >
                                                                                                    Cancel
                                                                                                </button>
                                                                                            ) : null}
                                                                                            <button
                                                                                                onClick={() =>
                                                                                                    handleCashReceivedClick(
                                                                                                        tx,
                                                                                                        toCashValue,
                                                                                                        networkFeeValue
                                                                                                    )
                                                                                                }
                                                                                                className={isNodeOperator ? styles.progressButton3 : styles.progressButton2}
                                                                                            >
                                                                                                {isNodeOperator
                                                                                                    ? 'Cash Received on behalf of user'
                                                                                                    : 'Cash Received'}
                                                                                            </button>
                                                                                        </>
                                                                                    ) : disputeOpen ? (
                                                                                        isNodeOperator ? (
                                                                                            <button
                                                                                                className={`${styles.progressButton3} ${styles.progressButtonDisabled}`}
                                                                                            >
                                                                                                Dispute Open
                                                                                            </button>
                                                                                        ) : (
                                                                                            <button
                                                                                                className={`${styles.progressButton3} ${styles.progressButtonDisabled}`}
                                                                                            >
                                                                                                Dispute Submitted
                                                                                            </button>
                                                                                        )
                                                                                    ) : canDispute ? (
                                                                                        <>
                                                                                            <button
                                                                                                onClick={() => handleDisputeClick(tx)}
                                                                                                className={styles.progressButton}
                                                                                            >
                                                                                                Dispute
                                                                                            </button>
                                                                                            <button
                                                                                                className={`${styles.progressButton2} ${styles.progressButtonDisabled}`}
                                                                                            >
                                                                                                Cash Received
                                                                                            </button>
                                                                                        </>
                                                                                    ) : collateralExecuted && isNodeOperator ? (
                                                                                        <button
                                                                                            className={`${styles.progressButton3} ${styles.progressButtonDisabled}`}
                                                                                        >
                                                                                            Collateral Released
                                                                                        </button>
                                                                                    ) : collateralExecuted || (tx.ex_squads_transaction_status !== "" && tx.type?.toLowerCase() !== "c2c") ? (
                                                                                        <></>
                                                                                    ) : cashReceivedSubmitted ? (
                                                                                        isNodeOperator ? (
                                                                                            <button
                                                                                                onClick={() =>
                                                                                                    handleAfterSettleFundsClick(tx)
                                                                                                }
                                                                                                className={styles.progressButton3}
                                                                                            >
                                                                                                Collateral Pending
                                                                                            </button>
                                                                                        ) : (
                                                                                            <button
                                                                                                className={`${styles.progressButton2} ${styles.progressButtonDisabled}`}
                                                                                            >
                                                                                                Cash Received
                                                                                            </button>
                                                                                        )
                                                                                    ) : (
                                                                                        <></>
                                                                                    )}
                                                                                </div> :
                                                                                <div style={{height: "45px"}}></div>

                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </CSSTransition>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )
                                    )
                                    }
                                </>
                            )}
                        </>
                    )}
                    {hasCumulativeInterest && !isLoading && hasMore && (<div className={styles.transactionRow}
                                                                             style={{
                                                                                 backgroundColor: isBlinking ? "#2A2A2A" : "#1C1C1C",
                                                                                 transition: "background-color 0.6s ease",
                                                                             }}></div>)}

                </div>

            </div>

            {showCashReceivedConfirm && orderDetails && (
                <C2COrderDetail
                    cashDeliveryAmount={`${(
                        Math.ceil(orderDetails.cashDeliveryAmount * 100) / 100
                    ).toFixed(2)} USDi`}
                    orderTips={`${(orderDetails.orderTips / kiraPrice).toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2,
                    })} KRA ($${(Math.floor(orderDetails.orderTips * 100) / 100).toFixed(2)})`}
                    fulfillDeadline={orderDetails.fulfillDeadline}
                    collateralRequired={`${(
                        Math.ceil(orderDetails.collateralRequired * 100) / 100
                    ).toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2,
                    })} KRA`}
                    rate={kiraPrice}
                    collateralRatio={`${(orderDetails.collateralRatio * 100).toFixed(0)}%`}
                            onConfirm={async () => {
                        try {
                            await handleCashReceived();
                        } catch (error) {
                            console.error("Error in handleCashReceived:", error);
                            showNotification("error", error.message || "Cash received failed");
                        }
                    }}
                            onClose={() => {
                        setShowCashReceivedConfirm(false);
                        setOrderDetails(null);
                    }}
                    isFulfillOrder={false}
                />
            )}

            {showCancelOrderDetail && cancelOrderDetails && (
                <CancelOrderDetail
                    toAmount={`${(Math.ceil(cancelOrderDetails.amount * 100) / 100).toFixed(2)} USDi`}
                    onConfirm={async () => {
                        try {
                            await handleCancelCashRedeem();
                            setShowCancelOrderDetail(false);
                        } catch (error) {
                            console.error("Error in handleCashReceived:", error);
                        }
                    }}
                    onClose={() => {
                        setShowCancelOrderDetail(false);
                        setCancelOrderDetails(null);
                    }}
                />
            )}

            {showSettleFunds && (
                <SettleFunds
                    onClose={() => setShowSettleFunds(false)}
                    paymentInfo={selectedTx?.payment_info_object}
                    onConfirmTransfer={() => {
                        setShowSettleFunds(false);
                        setRefetchFlag(prev => prev + 1);
                    }}
                    selectedTx={selectedTx}
                />
            )}
            {showAfterSettleFunds && selectedTx && (
                <AfterSettleFunds
                    onClose={() => setShowAfterSettleFunds(false)}
                    selectedTx={selectedTx}
                    email={selectedTx.requestor_contact_email}
                    mobile_number={selectedTx.requestor_contact_mobile_number}
                />
            )}
        </div>
    );
}

export default TransactionHistory;
